'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M10.002 7.35a.536.536 0 0 0-1.004 0l-1.334 3.603a2.9 2.9 0 0 1-1.711 1.712L2.35 13.998a.536.536 0 0 0 0 1.005l3.603 1.333a2.9 2.9 0 0 1 1.711 1.711l1.334 3.604a.536.536 0 0 0 1.004 0l1.334-3.604a2.9 2.9 0 0 1 1.711-1.711l3.603-1.333a.536.536 0 0 0 0-1.005l-3.603-1.333a2.9 2.9 0 0 1-1.711-1.712zM18.802 2.21a.322.322 0 0 0-.604 0l-.8 2.162c-.175.476-.55.85-1.026 1.027l-2.162.8a.321.321 0 0 0 0 .603l2.162.8c.476.176.85.55 1.027 1.026l.8 2.162a.322.322 0 0 0 .602 0l.8-2.162c.177-.475.552-.85 1.027-1.026l2.162-.8a.321.321 0 0 0 0-.603l-2.162-.8a1.74 1.74 0 0 1-1.027-1.027z" clipRule="evenodd" /></svg>;
const IconSparkle = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconSparkle;